module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-03@2x.f747708f.jpg";